// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { AmountDetail } from './AmountDetail'


export const LoanAmountsAppliedFor = ({ cashAppliedFor, retailAppliedFor, consolidationAppliedFor, changeCashAmountAppliedFor, changeRetailAmountAppliedFor, changeConsolidationAmountAppliedFor, changeFailedFields=[], changeSuccessFields=[], readOnly, creditApplication }) => (
  <div className='slds-p-top_small slds-p-bottom_small slds-p-left_medium slds-m-bottom_medium' style={{ backgroundColor: '#f5f5f5'}}>
    <div className='u-font-size-larger slds-m-bottom_small'>
      <b>{`Loan amount${creditApplication ? '' : 's'} applied for`}</b>
    </div>
    {creditApplication
      ? cashAppliedFor
        ? <AmountDetail label='Cash' value={cashAppliedFor} onChange={changeCashAmountAppliedFor} readOnly={readOnly} />
        : retailAppliedFor
          ? <AmountDetail label='Retail' value={retailAppliedFor} onChange={changeRetailAmountAppliedFor} readOnly={readOnly} />
          : <AmountDetail label='Consolidation' value={consolidationAppliedFor} onChange={changeConsolidationAmountAppliedFor} readOnly={readOnly} />
      : <React.Fragment>
          <AmountDetail label='Cash' value={cashAppliedFor} onChange={changeCashAmountAppliedFor} readOnly={readOnly} />
          <AmountDetail label='Retail' value={retailAppliedFor} onChange={changeRetailAmountAppliedFor} readOnly={readOnly} />
          <AmountDetail label='Consolidation' value={consolidationAppliedFor} onChange={changeConsolidationAmountAppliedFor} readOnly={readOnly} />
        </React.Fragment>
    }
  </div>
)

LoanAmountsAppliedFor.propTypes = {
  cashAppliedFor: PropTypes.number,
  retailAppliedFor: PropTypes.number,
  consolidationAppliedFor: PropTypes.number,
  changeFailedFields: PropTypes.array,
  readOnly: PropTypes.bool,
  creditApplication: PropTypes.bool
}

LoanAmountsAppliedFor.defaultProps = {
  cashAppliedFor: '',
  retailAppliedFor: '',
  consolidationAppliedFor: '',
  creditApplication: false
}



// WEBPACK FOOTER //
// ./src/components/loanapplication-info/LoanAmountsAppliedFor.js